import { render } from "./CreditLoanDetails.vue?vue&type=template&id=2bd7e278&scoped=true"
import script from "./CreditLoanDetails.vue?vue&type=script&lang=js"
export * from "./CreditLoanDetails.vue?vue&type=script&lang=js"

import "./CreditLoanDetails.vue?vue&type=style&index=0&id=2bd7e278&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bd7e278"]])

export default __exports__